import { render, staticRenderFns } from "./Wp_group_member_app.vue?vue&type=template&id=1cbb4ca8&scoped=true&"
import script from "./Wp_group_member_app.vue?vue&type=script&lang=js&"
export * from "./Wp_group_member_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbb4ca8",
  null
  
)

export default component.exports